module.exports = __webpack_public_path__ + "media/icons/logo-360-Response-f405da80.svg";